<template>
  <div>
    <a-row style="margin-bottom: 16px">
      晶体模型：
      <a-select style="width:200px" placeholder="选择模型" v-model="selectValue">
        <a-select-option v-for="m in models" :value="m.key">{{m.key}}</a-select-option>
      </a-select>
    </a-row>
    <div ref="mountNode" style="font-size:0"></div>

    <a-row style="width:500px">
      <a-col :span="12">
        <a-table
          :columns="columns1"
          :dataSource="[{}]"
          bordered
          :pagination="false"
          style="margin-top:14px;width:100%;"
        >
          <span slot="normalSymbol" slot-scope="text">
            <a-input style="width:100%" v-model="normalSymbol" />
          </span>
          <span slot="nationalSymbol" slot-scope="text">
            <point-type-selector v-model="nationalSymbol" />
          </span>
        </a-table>
      </a-col>
      <a-col :span="12">
        <a-table
          :columns="columns2"
          :dataSource="[{}]"
          bordered
          :pagination="false"
          style="margin-top:14px;width:100%;"
        >
          <span slot="crystalCluster" slot-scope="text">
            <crystal-cluster-selector v-model="crystalCluster" />
          </span>
          <span slot="crystalSys" slot-scope="text">
            <crystal-sys-selector v-model="crystalSys" />
          </span>
        </a-table>
      </a-col>
    </a-row>

    <a-table
      :columns="columns3"
      :dataSource="[{}]"
      bordered
      :pagination="false"
      style="margin-top:6px;width:500px;"
    >
      <span slot="singleElementSymbol" slot-scope="text">
        <a-textarea style="width:100%" v-model="singleElementSymbol" />
      </span>
      <span slot="singleElementName" slot-scope="text">
        <a-textarea style="width:100%" v-model="singleElementName" />
      </span>
      <span slot="crystalFaceNumber" slot-scope="text">
        <a-textarea style="width:100%" v-model="crystalFaceNumber" />
      </span>
    </a-table>
  </div>
</template>

<script>
import CrystalClusterSelector from './CrystalClusterSelector'
import CrystalSysSelector from './CrystalSysSelector'
import PointTypeSelector from './PointTypeSelector'

import Stage3D from '../utils/stage-3d'
import { loadGltf } from '../utils/loader'
import html2canvas from 'html2canvas'
import CONFIG from '@/config'

const columns1 = [{
  title: '对称型',
  dataIndex: 'symTyp',
  key: 'symTyp',
  children: [{
    title: '一般符号',
    dataIndex: 'normalSymbol',
    key: 'normalSymbol',
    width: '50%',
    scopedSlots: { customRender: 'normalSymbol' }
  }, {
    title: '国际符号',
    dataIndex: 'nationalSymbol',
    key: 'nationalSymbol',
    width: '50%',
    scopedSlots: { customRender: 'nationalSymbol' }
  }]
}]
const columns2 = [{
  title: '对称分类',
  dataIndex: 'symCategory',
  key: 'symCategory',
  children: [{
    title: '晶族',
    dataIndex: 'crystalCluster',
    key: 'crystalCluster',
    width: '50%',
    scopedSlots: { customRender: 'crystalCluster' }
  }, {
    title: '晶系',
    dataIndex: 'crystalSys',
    key: 'crystalSys',
    width: '50%',
    scopedSlots: { customRender: 'crystalSys' }
  }]
}]
const columns3 = [{
  title: '聚形分析',
  dataIndex: 'singleElement',
  key: 'singleElement',
  children: [{
    title: '单形符号',
    dataIndex: 'singleElementSymbol',
    key: 'singleElementSymbol',
    width: '33%',
    scopedSlots: { customRender: 'singleElementSymbol' }
  }, {
    title: '单形名称',
    dataIndex: 'singleElementName',
    key: 'singleElementName',
    width: '33%',
    scopedSlots: { customRender: 'singleElementName' }
  }, {
    title: '晶面数目',
    dataIndex: 'crystalFaceNumber',
    key: 'crystalFaceNumber',
    width: '33%',
    scopedSlots: { customRender: 'crystalFaceNumber' }
  }]
}]

export default {
  stage: null,

  components: {
    CrystalClusterSelector,
    CrystalSysSelector,
    PointTypeSelector
  },

  props: {
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 500
    }
  },

  data () {
    return {
      columns1,
      columns2,
      columns3,

      models: CONFIG.models,
      selectValue: CONFIG.models[0].key,
      
      normalSymbol: '',
      nationalSymbol: undefined,
      crystalCluster: undefined,
      crystalSys: undefined,

      singleElementSymbol: '',
      singleElementName: '',
      crystalFaceNumber: ''
    }
  },

  computed: {
    currentModel () {
      const match = this.models.find(m => m.key === this.selectValue)
      return match ? match.path : ''
    }
  },

  watch: {
    currentModel (value) {
      this.loadModel(value)
    },
    selectValue () {
      this.normalSymbol = ''
      this.nationalSymbol = undefined
      this.crystalCluster = undefined
      this.crystalSys = undefined
      this.singleElementSymbol = ''
      this.singleElementName = ''
      this.crystalFaceNumber = ''
    }
  },

  mounted () {
    this.createStage()

    if (this.currentModel) {
      this.loadModel(this.currentModel)
    }
  },

  methods: {
    createStage () {
      this.$options.stage = new Stage3D(this.$refs.mountNode, {
        width: this.width,
        height: this.height
      })
    },

    loadModel (modelUrl) {
      const stageScene = this.$options.stage.scene
      loadGltf(modelUrl).then(gltf => {
        if (this.lastModel) {
          stageScene.remove(this.lastModel)
        }
        const { geometry } = gltf.scene.children[0]//.children[0]
        geometry.computeVertexNormals()

        stageScene.add(gltf.scene)
        this.lastModel = gltf.scene
      })
    },

    getModelImage () {
      return html2canvas(this.$refs.mountNode).then(canvas => canvas.toDataURL())
    },

    getModelInfo () {
      const { 
        normalSymbol, nationalSymbol,
        crystalCluster, crystalSys,
        singleElementSymbol,
        singleElementName,
        crystalFaceNumber,
      } = this
      return {
        modelKey: this.selectValue,
        normalSymbol,
        nationalSymbol,
        crystalCluster,
        crystalSys,
        singleElementSymbol,
        singleElementName,
        crystalFaceNumber,
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Model3D.vue